import getAppLayout from '../getAppLayout'

const { hostname } = window.location
const { companyName } = getAppLayout(hostname)

// reffers to REACT_APP_LANG env
export default {
  'en-AU': {
    flyer: 'catalogue',
    otherDeals: 'Other {{category}} deals',
    allAbout: 'Everything about',
    show: 'Show',
    expiringStatus: {
      new: 'New',
      'coming-soon': 'Coming soon',
    },
    day: 'day',
    days: 'days',
    disclaimer: `${companyName} is not responsible for the content within the catalogues.<br/>If there is different information in this section, when compared to the catalogue, then what is indicated in the catalogue should prevail.`,
  },
  'en-NZ': {
    flyer: 'catalogue',
    otherDeals: 'Other {{category}} deals',
    allAbout: 'Everything about',
    show: 'Show',
    expiringStatus: {
      new: 'New',
      'coming-soon': 'Coming soon',
    },
    day: 'day',
    days: 'days',
    disclaimer: `${companyName} is not responsible for the content within the catalogues.<br/>If there is different information in this section, when compared to the catalogue, then what is indicated in the catalogue should prevail.`,
  },
  'en-GB': {
    flyer: 'catalogue',
    otherDeals: 'Other {{category}} deals',
    allAbout: 'Everything about',
    show: 'Show',
    expiringStatus: {
      new: 'New',
      'coming-soon': 'Coming soon',
    },
    day: 'day',
    days: 'days',
    disclaimer: `${companyName} is not responsible for the content within the catalogues.<br/>If there is different information in this section, when compared to the catalogue, then what is indicated in the catalogue should prevail.`,
  },
  'en-ZA': {
    flyer: 'catalogue',
    otherDeals: 'Other {{category}} deals',
    allAbout: 'Everything about',
    show: 'Show',
    expiringStatus: {
      new: 'New',
      'coming-soon': 'Coming soon',
    },
    day: 'day',
    days: 'days',
    disclaimer: `${companyName} is not responsible for the content within the catalogues.<br/>If there is different information in this section, when compared to the catalogue, then what is indicated in the catalogue should prevail.`,
  },
  es: {
    flyer: 'oferta',
    otherDeals: 'Otras ofertas de {{category}}',
    allAbout: 'Todo sobre',
    show: 'Mostrar',
    expiringStatus: {
      new: 'Nuevo',
      'coming-soon': 'Próximamente',
    },
    day: 'día',
    days: 'días',
    disclaimer: `${companyName} no se responsabiliza del contenido indicado en los folletos.<br/>En caso de incrongruencias entre esta sección y el folleto, prevalece el contenido del folleto.`,
  },
  it: {
    flyer: 'volantino',
    otherDeals: 'Altre offerte di {{category}}',
    allAbout: 'Tutto su',
    show: 'Mostra',
    expiringStatus: {
      new: 'Nuovo',
      'coming-soon': 'In Arrivo',
    },
    day: 'giorno',
    days: 'giorni',
    disclaimer: `${companyName} non è responsabile del contenuto indicato nei volantini.<br/>In caso di differenti informazioni tra questa sezione e il volantino, prevale quanto indicato nel volantino.`,
  },
  'pt-BR': {
    flyer: 'promocoes',
    otherDeals: 'Outras ofertas de {{category}}',
    allAbout: 'Tudo sobre',
    show: 'Mostrar',
    expiringStatus: {
      new: 'Novo',
      'coming-soon': 'Em breve',
    },
    day: 'dia',
    days: 'dias',
    disclaimer: `${companyName} não se responsabiliza pelo conteúdo presente nos encartes.<br/>No caso exista alguma diferença de informação entra essa seção e o encarte, prevalece quanto indicado no encarte.`,
  },
  pt: {
    flyer: 'folheto',
    otherDeals: 'Outras {{category}} promoções',
    allAbout: 'Tudo sobre',
    show: 'Mostrar',
    expiringStatus: {
      new: 'Novo',
      'coming-soon': 'Em breve',
    },
    day: 'dia',
    days: 'dias',
    disclaimer: `${companyName} não é responsável pelo conteúdo dos folhetos.<br/>Se houver informações diferentes nesta secção, quando comparadas com o folheto, então o que está indicado no folheto deve prevalecer.`,
  },
  fr: {
    flyer: 'catalogue',
    otherDeals: 'Autres offres de {{category}}',
    allAbout: 'Tout sur',
    show: 'Montrer',
    expiringStatus: {
      new: 'Nouveau',
      'coming-soon': 'Bientôt disponible',
    },
    day: 'journée',
    days: 'journées',
    disclaimer: `${companyName} n'est pas responsable du contenu des catalogues.<br/>S'il y a des informations différentes dans cette section, par rapport au catalogue, alors ce qui est indiqué dans le catalogue doit prévaloir`,
  },
  de: {
    flyer: 'Prospekt',
    otherDeals: 'Weitere Angebote aus {{category}}',
    allAbout: 'Alles über',
    show: 'Anzeigen',
    expiringStatus: {
      new: 'Neu',
      'coming-soon': 'Demnächst verfügbar',
    },
    day: 'Tag',
    days: 'Tage',
    disclaimer: `${companyName} ist nicht für den Inhalt der Prospekte verantwortlich.<br/>Sollten sich die Informationen in diesem Bereich von denen im Prospekt unterscheiden, so gelten die Angaben im Prospekt.`,
  },
  'de-AT': {
    flyer: 'Flugblatt',
    otherDeals: 'Weitere Angebote aus {{category}}',
    allAbout: 'Alles über',
    show: 'Anzeigen',
    expiringStatus: {
      new: 'Neu',
      'coming-soon': 'Demnächst',
    },
    day: 'Tag',
    days: 'Tage',
    disclaimer: `${companyName} ist nicht für den Inhalt der Flugblätter verantwortlich.<br/>Sollten sich die Informationen in diesem Bereich von denen im Flugblatt unterscheiden, so gelten die Angaben im Flugblatt.`,
  },
  pl: {
    flyer: 'gazetka',
    otherDeals: 'Inne okazje w {{category}}',
    allAbout: 'Wszystko o',
    show: 'Pokaż',
    expiringStatus: {
      new: 'Nowość',
      'coming-soon': 'Wkrótce',
    },
    day: 'dzień',
    days: 'dni',
    disclaimer: `${companyName} nie ponosi odpowiedzialności za treść gazetek.<br/>W przypadku rozbieżności między informacjami w tej sekcji a informacjami w gazetce, pierwszeństwo mają informacje zawarte w gazetce.`,
  },
  bg: {
    flyer: 'каталог',
    otherDeals: 'Други оферти от {{category}}',
    allAbout: 'Всичко за',
    show: 'Покажи',
    expiringStatus: {
      new: 'Ново',
      'coming-soon': 'Очаквайте скоро',
    },
    day: 'ден',
    days: 'дни',
    disclaimer: `${companyName} не носи отговорност за съдържанието в каталозите.<br/>Ако има различна информация в този раздел, в сравнение с каталога, тогава посоченото в каталога следва да е с предимство.`,
  },
  hu: {
    flyer: 'katalógus',
    otherDeals: 'További {{category}} ajánlatok',
    allAbout: 'Minden a(z)',
    show: 'Megtekintés',
    expiringStatus: {
      new: 'Új',
      'coming-soon': 'Hamarosan',
    },
    day: 'nap',
    days: 'napok',
    disclaimer: `A(z) ${companyName} nem vállal felelősséget a katalógusokban szereplő tartalmakért.<br/>Ha ebben a részben a katalógusban szereplőktől eltérő információ található, akkor a katalógusban feltüntetett adatok az irányadóak.`,
  },
  ro: {
    flyer: 'catalog',
    otherDeals: 'Alte oferte {{category}}',
    allAbout: 'Totul despre',
    show: 'Afișează',
    expiringStatus: {
      new: 'Nou',
      'coming-soon': 'În curând',
    },
    day: 'zi',
    days: 'zile',
    disclaimer: `${companyName} nu este responsabilă pentru conținutul din cataloage.<br/>Dacă există informații diferite în această secțiune, în comparație cu catalogul, atunci va prevala ceea ce este indicat în catalog.`,
  },
  'cs-CZ': {
    flyer: 'akční leták',
    otherDeals: 'Další nabídky v kategorii {{category}}',
    allAbout: 'Vše o',
    show: 'Zobrazit',
    expiringStatus: {
      new: 'Novinka',
      'coming-soon': 'Již brzy',
    },
    day: 'den',
    days: 'dní',
    disclaimer: `${companyName} neodpovídá za obsah letáků.<br/>Pokud se informace v této sekci liší od informací v letáku, platí informace uvedené v letáku.`,
  },
  nl: {
    flyer: 'folder',
    otherDeals: 'Andere {{category}} aanbiedingen',
    allAbout: 'Alles over',
    show: 'Bekijken',
    expiringStatus: {
      new: 'Nieuw',
      'coming-soon': 'Binnenkort',
    },
    day: 'dag',
    days: 'dagen',
    disclaimer: `${companyName} is niet verantwoordelijk voor de inhoud van de folders.<br/>Indien er in deze sectie andere informatie staat dan in de folder, is de informatie in de folder leidend.`,
  },
  sk: {
    flyer: 'akciový leták',
    otherDeals: 'Ďalšie ponuky v kategórii {{category}}',
    allAbout: 'Všetko o',
    show: 'Zobraziť',
    expiringStatus: {
      new: 'Novinka',
      'coming-soon': 'Už čoskoro',
    },
    day: 'deň',
    days: 'dní',
    disclaimer: `${companyName} nezodpovedá za obsah letákov.<br/>Ak sa informácie v tejto sekcii líšia od informácií v letáku, platia informácie uvedené v letáku.`,
  },
}
